import './ExpenseItem.css'
import ExpenseDate from './ExpenseDate.js';
import React from "react";
import Card from '../UI/Card.js'

const ExpenseItem = props => { 
  return(
      <Card className="expense-item"> 
        <ExpenseDate date={props.date}/>
        <div className="expense-item__description">
         <h2>{props.title}</h2> 
         <div className="expense-item__price">${props.price}</div>
        </div>
      </Card>
      );
}

export default ExpenseItem;